import { useTranslation } from "react-i18next";
import { Link, useParams } from "react-router";

import { EmptyState, ErrorState, Page, Spinner } from "@/components/ui";
import { formatDate } from "@/lib/format";
import { ImportMapping } from "@/tarjetas/ImportMapping";
import { ImportResult } from "@/tarjetas/ImportResult";
import { useCardImport } from "@/tarjetas/queries";

/**
 * One import: its mapping while it waits to be run, its report once it has.
 *
 * The same address for both, so the report a seller lands on after
 * *Importar* is the one they can come back to — and send to whoever asked why
 * forty cards did not make it in.
 */
export function ImportacionTarjetas() {
  const { t } = useTranslation();
  const id = Number(useParams().id);
  const { data, isPending, isError, refetch } = useCardImport(id);

  return (
    <Page
      title={data?.name ?? t("cards.import.title")}
      subtitle={
        <Link to="/tarjetas/importar" className="text-brand-700">
          {t("cards.import.backToImports")}
        </Link>
      }
      actions={
        data && data.card_count > 0 ? (
          <Link to={`/tarjetas?importacion=${data.id}`} className="btn btn-secondary">
            {t("cards.import.seeCards", { count: data.card_count })}
          </Link>
        ) : null
      }
    >
      {isPending ? (
        <Spinner label={t("common.loading")} />
      ) : isError ? (
        <ErrorState message={t("errors.cardImport")} onRetry={() => void refetch()} />
      ) : (
        <>
          <p className="mb-5 text-[13px] text-mute-600">
            {[data.file_name, data.created_by_agent_name, formatDate(data.created)]
              .filter(Boolean)
              .join(" · ")}
          </p>
          {data.status === "pending" ? (
            data.preview ? (
              <ImportMapping importId={data.id} preview={data.preview} />
            ) : (
              <EmptyState>{t("cards.import.unreadable")}</EmptyState>
            )
          ) : data.result ? (
            <ImportResult result={data.result} />
          ) : (
            <EmptyState>{t("cards.import.noResult")}</EmptyState>
          )}
        </>
      )}
    </Page>
  );
}
